import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Plane,
  CreditCard,
  Crown,
  Gift,
  Users,
  Bell,
  Shield,
  HelpCircle,
  ChevronRight,
} from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";

const navigation = [
  {
    title: "Account",
    items: [
      { title: "Dashboard", href: "/account/dashboard", icon: LayoutDashboard },
      { title: "Bookings", href: "/account/bookings", icon: Plane },
      { title: "Transactions", href: "/account/transactions", icon: CreditCard },
      { title: "Membership", href: "/account/membership", icon: Crown },
    ],
  },
  {
    title: "Loyalty",
    items: [
      { title: "Points", href: "/account/points", icon: Gift },
      { title: "Rewards", href: "/account/rewards", icon: Gift },
    ],
  },
  {
    title: "Profile",
    items: [
      { title: "Travelers", href: "/account/travelers", icon: Users },
      { title: "Payment Methods", href: "/account/payments", icon: CreditCard },
      { title: "Notifications", href: "/account/notifications", icon: Bell },
      { title: "Security", href: "/account/security", icon: Shield },
      { title: "Support", href: "/account/support", icon: HelpCircle },
    ],
  },
];

export function AccountSidebar() {
  const { state } = useSidebar();
  const collapsed = state === "collapsed";

  return (
    <Sidebar className={collapsed ? "w-14" : "w-60"} collapsible="icon">
      <SidebarContent>
        {navigation.map((section) => (
          <SidebarGroup key={section.title}>
            {!collapsed && <SidebarGroupLabel>{section.title}</SidebarGroupLabel>}
            <SidebarGroupContent>
              <SidebarMenu>
                {section.items.map((item) => (
                  <SidebarMenuItem key={item.href}>
                    <SidebarMenuButton asChild>
                      <NavLink
                        to={item.href}
                        className={({ isActive }) =>
                          isActive
                            ? "bg-accent/20 text-primary font-medium"
                            : "hover:bg-accent/10"
                        }
                      >
                        <item.icon className="h-4 w-4" />
                        {!collapsed && <span>{item.title}</span>}
                        {!collapsed && <ChevronRight className="ml-auto h-4 w-4 opacity-50" />}
                      </NavLink>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>
    </Sidebar>
  );
}
